import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { UILoader } from '@futrli/ui-components';
import {
  APIClients,
  ApiClientType,
  auth0Authenticator,
  IntegrationsAPIClient,
  ROUTES,
  deleteAuth0Cookies,
  storeSfaBusinessId,
  getSfaBusinessIdFromUrl
} from '@futrli/shared-services';

import { signOut } from '../login/redux-utils/actions';
import { clearLocalStorageWithExceptions } from '@futrli/shared-services/string-utils/utils';

export const SfaTrigger = () => {
  const businessId = getSfaBusinessIdFromUrl();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!businessId) {
      navigate(ROUTES.ROOT_ROUTE);
      return;
    }

    // Initialize API clients, it needs to be Auth0 since
    // users will be authenticated with SageID
    APIClients.setApiClient(ApiClientType.Auth0);
    IntegrationsAPIClient.setApiClient(ApiClientType.Auth0);

    // Terminates current user session
    const deleteSessionDataAndSignIn = async () => {
      await dispatch(signOut());
      sessionStorage.clear();
      clearLocalStorageWithExceptions();
      deleteAuth0Cookies();

      // Save business id to session storage
      storeSfaBusinessId(businessId);

      // Immediately redirect user to SageId auth page
      auth0Authenticator.signIn();
    };

    deleteSessionDataAndSignIn();
  }, [businessId, navigate, dispatch]);

  return <UILoader isFull={true} />;
};
